import React, {Component} from 'react'
import {connect} from 'react-redux'
import BackOfficeNavigatorScreen from '../screens/BackOfficeNavigatorScreen'
import {Route, Switch, Redirect} from 'react-router-dom'
import { bindActionCreators } from 'redux'

import {actions as authActions} from '../redux/modules/Auth'
import SostaOnlineApiService from '../services/SostaOnlineApiService'
import BackOfficeMarksTableContainer from './BackOfficeMarksTableContainer'
import BackOfficeVehiclesTableContainer from './BackOfficeVehiclesTableContainer'
import BackOfficeParkingPassTableContainer from './BackOfficeParkingPassTableContainer'
import BackOfficeReceiptsTableContainer from './BackOfficeReceiptsTableContainer'
import BackOfficeReceiptCreateContainer from './BackOfficeReceiptCreateContainer'
import BackOfficeUserContainer from './BackOfficeUserContainer'
import BackofficeSettings from './Backoffice/Settings/BackofficeSettings'
import BackofficeReports from './Backoffice/Reports/BackofficeReports'
import BackofficeWaitingList from "./Backoffice/BackofficeWaitingList/BackofficeWaitingList"

const mapStateToProps = (state) => {
  return {
    state: state.auth
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authActions: bindActionCreators(authActions, dispatch)
  }
}

class BackOfficeContainer extends Component {
  constructor (props) {
    super(props)
    this.state = {
      thingsToDo: {
        waitingMarks: 0
      }
    }
  }

  componentWillMount () {
    this.fetchThingsToDo()
  }

  fetchThingsToDo () {
    SostaOnlineApiService.fetchThingsToDo().then(data => {
      this.setState({thingsToDo: data.data})
    })
  }

  onLogoutClick () {
    this.props.authActions.logout()
  }

  render () {
    return (
      <BackOfficeNavigatorScreen
        onMarksWaitingClick={() => this.props.history.push('/backoffice/users/waiting-list')}
        user={this.props.state.user}
        thingsToDo={this.state.thingsToDo}
        onLogoutClick={this.onLogoutClick.bind(this)}>
        <Switch>
          <Route path="/backoffice/marks" component={BackOfficeMarksTableContainer} />
          <Route
            path="/backoffice/users"
            component={(props) => <BackOfficeUserContainer thingsToDo={this.state.thingsToDo} {...props} />} />
          <Route path="/backoffice/vehicles" component={BackOfficeVehiclesTableContainer} />
          <Route path="/backoffice/parkingPasses" component={BackOfficeParkingPassTableContainer} />
          <Route path="/backoffice/receipts/create" component={BackOfficeReceiptCreateContainer} />
          <Route path="/backoffice/receipts" component={BackOfficeReceiptsTableContainer} />
          <Route path="/backoffice/settings" component={BackofficeSettings} />
          <Route path="/backoffice/reports" component={BackofficeReports} />
          <Route path="/backoffice/waiting-lists" component={BackofficeWaitingList} />
          <Redirect to="/backoffice/users" />
        </Switch>
      </BackOfficeNavigatorScreen>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackOfficeContainer)



// WEBPACK FOOTER //
// ./src/containers/BackOfficeContainer.js